<div class="tab-pane folay-horizontal-desktop show active pt-4 pt-md-0" *transloco="let t;">
	<div class="folay-top d-table px-3 px-md-4 text-center mt-2 mt-md-0">
		<div class="topbar">
			<div class="topbar-left-action text-dark">
				<ion-icon name="chevron-back" class="f24" (click)="back();" />
			</div>
		</div>

		<div class="folay-title d-table-row f24">
			<img class="mb-4" src="/assets/images/icon/upstation-black.svg" alt="UP Station Logo" loading="lazy">

			<div class="fsemibold">{{ t('modal.verification.verif_phone') }}</div>
			<div class="folay-subtitle">{{ t('modal.verification.verif_msg_1') }} <b>{{ phone.replace('%2b', '+') }}</b>{{ t('modal.verification.verif_msg_2') }}</div>
		</div>
	</div>

	<form [formGroup]="form" class="folay-dark-container mt-3 mt-md-0">
		<ups-pin formControlName="otp" [obsecure]="false" />

		<div class="text-center u-body-3 text-white">
			{{ t('modal.verification.no_code') }}
			
            @if (second === 0) {
				<a type="button" class="u-body-3 text-primary" (click)="resend();">{{ t('button.resend') }}</a>
			} @else {
				<span class="u-body-3 text-primary">{{ second }}</span>
			}
		</div>

		<button class="btn btn-thumb btn-primary btn-block mt-4 fsemibold" (click)="verify();" #btn>{{ t('button.verification') }}</button>
	</form>
</div>
